
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/editorSearch/views/SearchResultsList/SearchResultsList.scss.css.virtualfile';
        module.exports = {"container":"_container_whnqz_1"};